export enum PackageName {
    Essential = "Essential",
    Advanced = "Advanced",
    EssentialMonthly = "Digital Marketing - Essential Monthly",
    EssentialAnnual = "Digital Marketing - Essential Annual",
    AdvancedMonthly = "Digital Marketing - Advanced Monthly",
    AdvancedAnnual = "Digital Marketing - Advanced Annual",
    Business = "Competitive Intelligence - Business",
    Team = "Competitive Intelligence - Team",
    BusinessInvestors = "Competitive Intelligence - Business for Investors",
    Enterprise = "Competitive Intelligence - Enterprise",
    ExplorerMonthly = "Competitive Intelligence - Explorer Monthly",
    ExplorerAnnual = "Competitive Intelligence - Explorer Annual",
    StarterMonthly = "Competitive Intelligence - Starter Monthly", // 3.0 version of CompetitiveIntelligenceMonthly
    StarterAnnual = "Competitive Intelligence - Starter Annual", // 3.0 version of CompetitiveIntelligenceAnnual
    ProfessionalMonthly = "Competitive Intelligence - Professional Monthly", // 3.0 version of CompetitiveIntelligenceSeoAeoMonthly
    ProfessionalAnnual = "Competitive Intelligence - Professional Annual", // 3.0 version of CompetitiveIntelligenceSeoAeoAnnual
    CompetitiveIntelligenceMonthly = "Competitive Intelligence - Monthly",
    CompetitiveIntelligenceAnnual = "Competitive Intelligence - Annual",
    CompetitiveIntelligenceSeoMonthly = "Competitive Intelligence & SEO - Monthly",
    CompetitiveIntelligenceSeoAnnual = "Competitive Intelligence & SEO - Annual",
    CompetitiveIntelligenceSeoAeoMonthly = "Competitive Intelligence & SEO & AEO - Monthly",
    CompetitiveIntelligenceSeoAeoAnnual = "Competitive Intelligence & SEO & AEO - Annual",
    AeoIntelligenceMonthly = "AEO Intelligence Monthly",
    AeoIntelligenceAnnual = "AEO Intelligence Annual",
    AeoCompetitiveIntelligenceSeoMonthly = "AEO & Competitive Intelligence & SEO - Monthly",
    AeoCompetitiveIntelligenceSeoAnnual = "AEO & Competitive Intelligence & SEO - Annual",
    CompetitiveIntelligenceSeoAeoAdsMonthly = "Competitive Intelligence & SEO & AEO & ADs - Monthly",
    CompetitiveIntelligenceSeoAeoAdsAnnual = "Competitive Intelligence & SEO & AEO & ADs - Annual",
    GrowMonthly = "Grow - No Touch - Monthly",
    GrowAnnual = "Grow - No Touch - Annual",
}

export const packagesDisplayName: Partial<Record<PackageName, string>> = {
    [PackageName.EssentialMonthly]: "Essential",
    [PackageName.EssentialAnnual]: "Essential",
    [PackageName.AdvancedMonthly]: "Advanced",
    [PackageName.AdvancedAnnual]: "Advanced",
    [PackageName.Business]: "Business",
    [PackageName.Team]: "Team",
    [PackageName.BusinessInvestors]: "Business for Investors",
    [PackageName.Enterprise]: "Enterprise",
    [PackageName.ExplorerMonthly]: "Explorer Monthly",
    [PackageName.ExplorerAnnual]: "Explorer Annual",
    [PackageName.StarterAnnual]: "Starter Monthly",
    [PackageName.StarterMonthly]: "Starter Annual",
    [PackageName.ProfessionalMonthly]: "Professional Monthly",
    [PackageName.ProfessionalAnnual]: "Professional Annual",
    [PackageName.CompetitiveIntelligenceAnnual]: "Competitive Intelligence - Annual",
    [PackageName.CompetitiveIntelligenceMonthly]: "Competitive Intelligence - Monthly",
    [PackageName.CompetitiveIntelligenceSeoAnnual]: "Competitive Intelligence & SEO - Annual",
    [PackageName.CompetitiveIntelligenceSeoMonthly]: "Competitive Intelligence & SEO - Monthly",
    [PackageName.CompetitiveIntelligenceSeoAeoAnnual]: "Competitive Intelligence & SEO & AEO - Annual",
    [PackageName.CompetitiveIntelligenceSeoAeoMonthly]: "Competitive Intelligence & SEO & AEO - Monthly",
    [PackageName.AeoIntelligenceAnnual]: "AEO Intelligence Annual",
    [PackageName.AeoIntelligenceMonthly]: "AEO Intelligence Monthly",
    [PackageName.AeoCompetitiveIntelligenceSeoAnnual]: "AEO & Competitive Intelligence & SEO - Annual",
    [PackageName.AeoCompetitiveIntelligenceSeoMonthly]: "AEO & Competitive Intelligence & SEO - Monthly",
};
